import React ,{useEffect,Fragment} from 'react';
// import styled from "styled-components";
import {Route, Redirect,withRouter} from "react-router-dom";
import { spring, AnimatedSwitch } from 'react-router-transition';
import Div100vh from 'react-div-100vh'
import './asset/css/icon.css';
import './asset/css/fonts.css';
import './asset/css/styles.css';

import CrusorHover from './component/utility/crusorHover'
import Home from './Home';
import Homework from './Homework';
import Archive from './Archive';
// import SinglePost from './SinglePost';
import Maps from './Map';
import Work from './Work';
import About from './About';
import Search from './Search';

import {connect} from 'react-redux';
import {isLoadingFrist} from "./redux/actions"

function mapStyles(styles) {
  return {
    transform: `translate(${styles.left}%,0)` ,
    // opacity: styles.opacity,
  };
}
function bounce(val) {
  return spring(val, {
    stiffness: 400,
    damping: 60,
  });
}
const bounceTransition = {
  atEnter: {
    left:-100,
  },
  atLeave: {
    left:bounce(0.1),
  },
  atActive: {
    left:bounce(0),
  },
};



const App = ({location,loadingRedux,loadingFrist,isLoadingFrist}) =>{
  useEffect(() => {
    
      
      //   console.log(loadingFrist)
      
      // isLoadingFrist(true)
 
  }, [])
  // console.log(loadingFrist)
  return (
    <Fragment>
      <Div100vh style={{height:"100rvh",overflow:"hidden"}}>
      <AnimatedSwitch
      atEnter={bounceTransition.atEnter}
      atLeave={bounceTransition.atLeave}
      atActive={bounceTransition.atActive}
      mapStyles={mapStyles}
      className={`switch-wrapper ${loadingRedux?"active":loadingFrist?"frist":""}`}
    >
      <Route exact path="/" component={Home} />
      <Route exact path="/work" component={Homework} />
      <Route exact path="/archive" component={Archive} />
      {/* <Route path="/archive/:name" component={SinglePost} /> */}
      <Route exact path="/contact" component={Maps} />
      <Route exact path="/about" component={About} />
      <Route exact path="/search/:name" component={Search} />
      <Route  path="/:pagename/:name" component={Work} />
      <Redirect  to="/"/>
      </AnimatedSwitch>
        <CrusorHover/>
      </Div100vh>
  </Fragment>
  )
}
const mapStateToProps = ({loading}) => {
  return {
      loadingRedux: loading.type,
      loadingFrist: loading.loadingfrist,
  }
};

export default withRouter(connect(mapStateToProps,{isLoadingFrist})(App));